import request from '../utils/request'
export function addProject (data) {
  return request({
    url: 'project',
    method: 'post',
    data
  })
}
export function updateProject (data) {
  return request({
    url: 'project',
    method: 'put',
    data
  })
}
export function updateProjectReview (data) {
  return request({
    url: 'project/updateProjectReview',
    method: 'put',
    data
  })
}
export function updateMaintainUser (data) {
  return request({
    url: '/project/updateMaintainUser',
    method: 'put',
    data
  })
}
export function updateProjectLevel (data) {
  return request({
    url: '/project/updateProjectLevel',
    method: 'put',
    data
  })
}
export function listProject (data) {
  return request({
    url: 'project',
    method: 'get',
    params: data
  })
}
export function searchProject (data) {
  return request({
    url: 'platformMedia/searchProject',
    method: 'POST',
    data: data
  })
}
export function countProject (data) {
  return request({
    url: 'project/count',
    method: 'get',
    params: data
  })
}
export function deleteProject (data) {
  return request({
    url: 'project/' + data,
    method: 'DELETE'
  })
}

export function batchDeleteProject (data) {
  return request({
    url: 'project/batchDelete',
    method: 'POST',
    data
  })
}

export function createCustomer (data) {
  return request({
    url: 'customer',
    method: 'post',
    data
  })
}
export function listCustomer (data) {
  return request({
    url: 'customer',
    method: 'get',
    params: data
  })
}
export function updateCustomer (data) {
  return request({
    url: 'customer',
    method: 'put',
    data
  })
}
export function queryCustomerOpenBankInfo (data) {
  return request({
    url: 'customer/queryCustomerOpenBankInfo',
    method: 'get',
    params: {
      customerId: data
    }
  })
}

export function queryOpenbankByCustomerId (data) {
  return request({
    url: 'customer/queryCustomerOpenBankInfoById',
    method: 'get',
    params: {
      customerId: data
    }
  })
}
export function deleteCustomer (data) {
  return request({
    url: 'customer/' + data,
    method: 'delete'
  })
}
export function selectUsers (data) {
  return request({
    url: 'selectUser',
    method: 'get',
    params: data
  })
}

export function createBuilding (data) {
  return request({
    url: 'building',
    method: 'post',
    data
  })
}

export function listBuilding (data) {
  return request({
    url: 'building',
    method: 'get',
    params: data
  })
}

export function listAllBuilding (data) {
  return request({
    url: 'building/listAll',
    method: 'get',
    params: data
  })
}
export function deleteBuilding (data) {
  return request({
    url: 'building/' + data,
    method: 'delete'
  })
}

/**
 * 修改楼座
 * @param data
 */
export function updateBuilding (data) {
  return request({
    url: 'building',
    method: 'put',
    data
  })
}

/**
 * 分页查询单元
 * @param data
 */
export function listUnit (data) {
  return request({
    url: 'unit',
    method: 'get',
    params: data
  })
}
/**
 * 创建单元
 * @param data
 */
export function createUnit (data) {
  return request({
    url: 'unit',
    method: 'post',
    data
  })
}

/**
 * 修改单元
 * @param data
 */
export function updateUnit (data) {
  return request({
    url: 'unit',
    method: 'put',
    data
  })
}
/**
 * 删除单元
 * @param data
 */
export function deleteUnit (data) {
  return request({
    url: 'unit/' + data,
    method: 'delete'
  })
}

/**
 * 查询所有单元
 * @param data
 */
export function listAllUnit (data) {
  return request({
    url: 'unit/listAll',
    method: 'get',
    params: data
  })
}

/**
 * 创建电梯
 * @param data
 */
export function createElevator (data) {
  return request({
    url: 'elevator',
    method: 'post',
    data
  })
}
/**
 * 修改电梯
 * @param data
 */
export function updateElevator (data) {
  return request({
    url: 'elevator',
    method: 'put',
    data
  })
}

/**
 * 删除电梯
 * @param data
 */
export function deleteElevator (data) {
  return request({
    url: 'elevator/' + data,
    method: 'delete'
  })
}
/**
 * 分页查询电梯
 * @param data
 */
export function listElevator (data) {
  return request({
    url: 'elevator',
    method: 'get',
    params: data
  })
}
/**
 * 查询所有电梯
 * @param data
 */
export function listAllElevator (data) {
  return request({
    url: 'elevator/listAll',
    method: 'get',
    params: data
  })
}

/**
 * 根据条件统计媒体位
 * @param data
 * @returns {AxiosPromise}
 */
export function mediaCountTotal (data) {
  return request({
    url: 'media/selectMediaCountByParam',
    method: 'get',
    params: data
  })
}
/**
 * 创建媒体位
 * @param data
 */
export function createMedia (data) {
  return request({
    url: 'media',
    method: 'post',
    data
  })
}
/**
 * 修改媒体位
 * @param data
 */
export function updateMedia (data) {
  return request({
    url: 'media',
    method: 'put',
    data
  })
}

/**
 * 删除媒体位
 * @param data
 */
export function deleteMedia (data) {
  return request({
    url: 'media/' + data,
    method: 'delete'
  })
}

/**
 * 媒体位安装状态BY电梯ID
 * @param data
 */
export function installPositions (data) {
  return request({
    url: 'media/' + data + '/installPositions',
    method: 'get'
  })
}
/**
 * 分页查询电梯
 * @param data
 */
export function listMedia (data) {
  return request({
    url: 'media',
    method: 'get',
    params: data
  })
}

/**
 * 通过项目Id查询禁忌行业
 * @param data
 */
export function selectTabooByProjectId (data) {
  return request({
    url: 'project/selectTabooByProjectId/' + data,
    method: 'get'
  })
}

/**
 * 通过项目查询城市数据
 * @param data
 */
export function selectCity () {
  return request({
    url: 'project/selectCity',
    method: 'get'
  })
}
/**
 * 查询项目详情
 * @param data
 */
export function getProjectInfo (data) {
  return request({
    url: 'project/selectOne/' + data,
    method: 'GET'
  })
}
/**
 * 分页查询安装单
 * @param data
 */
export function listConstruction (data) {
  return request({
    url: 'construction/list',
    method: 'get',
    params: data
  })
}

export function constructionInsert (data) {
  return request({
    url: 'construction',
    method: 'post',
    data
  })
}

export function constructionList (data) {
  return request({
    url: 'construction/list',
    method: 'get',
    params: data
  })
}
export function constructionUpdate (data) {
  return request({
    url: 'construction',
    method: 'put',
    data
  })
}
export function constructionSelectOne (data) {
  return request({
    url: 'construction',
    method: 'get',
    params: data
  })
}
/**
 * 通过项目ID查询未签约媒体位
 * @param data
 */
export function selectMediaByProjectId (data) {
  return request({
    url: 'media/' + data + '/medias',
    method: 'get'
  })
}
// 新增合同
export function contractInsert (data) {
  return request({
    url: 'contract',
    method: 'post',
    data: data
  })
}

export function contractUpdate (data) {
  return request({
    url: 'contract',
    method: 'put',
    data: data
  })
}
export function contractDelete (data) {
  return request({
    url: 'contract/' + data,
    method: 'delete'
  })
}
export function mediaContractiinsertList (data) {
  return request({
    url: 'mediaContract/insertList',
    method: 'post',
    data: data
  })
}
export function mediaContractByContractId (data, status) {
  return request({
    url: 'mediaContract/' + data + '/' + status + '/selectAll',
    method: 'get'
  })
}
export function mediaContractDeleteList (data) {
  return request({
    url: 'mediaContract/deleteList',
    method: 'delete',
    data: data
  })
}
export function palnpayInsertList (data) {
  return request({
    url: 'palnpay/insertList',
    method: 'post',
    data: data
  })
}
export function palnpayList (data) {
  return request({
    url: 'palnpay',
    method: 'get',
    params: data
  })
}
export function palnpayDeleteList (data) {
  return request({
    url: 'palnpay/deleteList',
    method: 'delete',
    data: data
  })
}
export function contractList (data) {
  return request({
    url: 'contract',
    method: 'get',
    params: data
  })
}
export function selectOneProject (data) {
  return request({
    url: 'project/' + data,
    method: 'get'
  })
}
export function addContractAudit (data) {
  return request({
    url: 'contractAudit',
    method: 'post',
    data: data
  })
}
export function selectContractById (data) {
  return request({
    url: 'contract/' + data,
    method: 'get'
  })
}

export function contractRenew (data) {
  return request({
    url: 'contract/renew',
    method: 'post',
    data: data
  })
}
export function constructionInstall (data) {
  return request({
    url: 'construction/install',
    method: 'post',
    data: data
  })
}
export function constructionNotInstall (data) {
  return request({
    url: 'construction/' + data + '/notInstall',
    method: 'get'
  })
}
export function constructionStatement (data) {
  return request({
    url: 'construction/' + data + '/statement',
    method: 'get'
  })
}

export function constructionDelete (data, installStatus) {
  return request({
    url: 'construction/' + data + '/' + installStatus,
    method: 'delete'
  })
}

/**
 * 上传图片
 * @param data
 */
export function uploadFile (data) {
  return request({
    url: 'file/uploadFile',
    method: 'post',
    data: data
  })
}
export function selectElevatorById (data) {
  return request({
    url: 'elevator/' + data,
    method: 'get'
  })
}
export function selectBuildingById (data) {
  return request({
    url: 'building/' + data,
    method: 'get'
  })
}
export function selectUnitById (data) {
  return request({
    url: 'unit/' + data,
    method: 'get'
  })
}
export function createOpenBank (data) {
  return request({
    url: 'customer/createOpenBank',
    method: 'POST',
    data
  })
}
/**
 *
 */
export function listDescribe (data) {
  return request({
    url: 'commonIndustry',
    method: 'get',
    params: data
  })
}
/**
 *查询所有媒体位
 */
export function allMediaList (data) {
  return request({
    url: 'allmedias',
    method: 'get',
    params: data
  })
}
/**
 *统计所有媒体位
 */
export function countMedia (data) {
  return request({
    url: 'allmedias/count',
    method: 'get',
    params: data
  })
}
/**
 * 修改楼盘状态
 */
export function updateProjectState (data) {
  return request({
    url: 'project/updateState',
    method: 'post',
    data
  })
}
/**
 * 修改楼栋状态
 */
export function updateBuildingState (data) {
  return request({
    url: 'building/updateState',
    method: 'post',
    data
  })
}
/**
 * 修改单元状态
 */
export function updateUnitState (data) {
  return request({
    url: 'unit/updateState',
    method: 'post',
    data
  })
}
/**
 * 修改电梯状态
 */
export function updateElevatorState (data) {
  return request({
    url: 'elevator/updateState',
    method: 'post',
    data
  })
}
/**
 * 修改媒体位状态
 */
export function updateMediaState (data) {
  return request({
    url: 'media/updateState',
    method: 'post',
    data
  })
}
/**
 * 批量可售
 */
export function updateBatchOnSale (data) {
  return request({
    url: 'allmedias/batchOnSale',
    method: 'put',
    data
  })
}

/**
 * 批量修改媒体位状态
 */
export function updateBatchMaintain (data) {
  return request({
    url: 'allmedias/batchMaintain',
    method: 'put',
    data
  })
}
/**
 * 批量修改媒体位状态
 */
export function updateBatchPreRemove (data) {
  return request({
    url: 'allmedias/batchPreRemove',
    method: 'put',
    data
  })
}

/**
 * 批量修改媒体位状态
 */
export function updateBatchRemove (data) {
  return request({
    url: 'allmedias/batchRemove',
    method: 'put',
    data
  })
}

/**
 * 批量修改媒体位状态
 */
export function updateBatchMediaState (data) {
  return request({
    url: 'allmedias',
    method: 'put',
    data
  })
}

/**
 * 查询共存媒体
 * @param data
 */
export function getCoexistenceList (data) {
  return request({
    url: 'project/coexistmeida',
    method: 'get',
    params: data
  })
}

/**
 * 生成人员数据
 * @param data
 */
export function createStaff (data) {
  return request({
    url: 'project/createstaff',
    method: 'post',
    data
  })
}
/**
 *查询共存媒体
 * @param data
 */
export function selectCoexistenceByProjectId (data) {
  return request({
    url: 'project/selectCoexistenceByProjectId/' + data,
    method: 'get'
  })
}
/**
 *新增行业
 * @param data
 */
export function createIndustry (data) {
  return request({
    url: 'commonIndustry',
    method: 'POST',
    data
  })
}
/**
 *修改行业名称
 * @param data
 */
export function updateIndustryName (data) {
  return request({
    url: 'commonIndustry',
    method: 'PUT',
    data
  })
}
/**
 *修改行业名称
 * @param data
 */
export function deleteIndustry (data) {
  return request({
    url: 'commonIndustry/deleteIndustry/' + data,
    method: 'DELETE'
  })
}
export function activatedMedia (data) {
  return request({
    url: 'media/activatedMedia/' + data,
    method: 'GET'
  })
}
export function queryErrorProject (data) {
  return request({
    url: 'project/queryErrorProject/',
    method: 'POST',
    data: data
  })
}
export function batchUpdateRegion (data) {
  return request({
    url: 'project/batchUpdateRegion/',
    method: 'POST',
    data: data
  })
}
export function searchShareRelation (data) {
  return request({
    url: '/shareRelation/search',
    method: 'POST',
    data: data
  })
}
export function updateShareRelation (data) {
  return request({
    url: '/shareRelation/update',
    method: 'PUT',
    data
  })
}
export function searchPlatformManagement (data) {
  return request({
    url: '/platformManagementData/search',
    method: 'GET',
    params: data
  })
}

// 批量更改楼盘状态
export function batchUpdateProjectState (data) {
  return request({
    url: '/project/batchUpdateState',
    method: 'POST',
    data
  })
}
// 导出到期楼盘
export function exportExpireProject (data) {
  return request({
    url: '/project/downloadExpiredProjects',
    method: 'GET',
    params: data
  })
}

// 导入到期楼盘
export function importExpireProject (data) {
  return request({
    url: '/project/importAndChangeExpiredProjects',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 下载导入失败的楼盘
export function downloadImportErrorProject (data) {
  return request({
    url: '/project/downloadFailExpiredProjects',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/resource.js